<template>
  <div>
    <v-dialog v-model="dialog" max-width="450px">
      <v-card class="elevation-12" dark>
        <v-toolbar flat>
          <v-toolbar-title><h3>登入</h3></v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-text-field
              label="帳號"
              name="login"
              prepend-icon="person"
              type="text"
              autofocus
              :rules="[rules.required, rules.userCounter]"
              :loading="status2.logging"
              validate-on-blur
              v-model="user"
              @keydown.space.prevent=""
              :counter="40"
            ></v-text-field>

            <v-text-field
              id="password"
              label="密碼"
              name="password"
              prepend-icon="lock"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              :type="showPassword ? 'text' : 'password'"
              :rules="[rules.required, rules.passCounter]"
              :loading="status2.logging"
              validate-on-blur
              v-model="pass"
              @click:append="showPassword = !showPassword"
              @keydown.space.prevent=""
              :counter="20"
            />
            <v-alert v-show="status2.loginFaile" dense outlined type="error">
              帳號或密碼錯誤
            </v-alert>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col class="pt-0 text-end">
              <v-btn
                v-if="getFeatureEnb('member_register')"
                class="my-btn mr-2"
                data-test="login-btn"
                color="primary"
                @click="handleOnRegister"
              >
                <h3>註冊</h3>
              </v-btn>
              <v-btn
                class="my-btn"
                data-test="login-btn"
                color="success"
                @click="handleOnLogin"
              >
                <h3>登入</h3>
              </v-btn>
            </v-col>
          </v-row>
          <!-- <v-spacer />
          <v-btn
            class="my-btn"
            data-test="login-btn"
            color="success"
            @click="handleOnLogin"
            ><h3>登入</h3></v-btn
          > -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2">
      <v-card class="elevation-12" dark>
        <v-toolbar flat>
          <v-toolbar-title><h3>帳號申請</h3></v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-card-text class="pb-0">
            <v-form
              ref="my-page3-register-form"
              v-model="InputValid"
              @submit.prevent=""
            >
              <!--  -->
              <v-row>
                <v-col class="pt-0 pb-0">
                  <v-row>
                    <v-col class="pt-0 pb-0">
                      <v-text-field
                        v-model="info.account"
                        label="帳號"
                        :rules="[rules.required, rules.userCounter]"
                        :counter="40"
                        require
                      ></v-text-field>
                    </v-col>
                    <v-col class="pt-0 pb-0">
                      <v-text-field
                        v-model="info.password"
                        label="密碼"
                        :append-icon="
                          showPassword2 ? 'visibility' : 'visibility_off'
                        "
                        :type="showPassword2 ? 'text' : 'password'"
                        @click:append="showPassword2 = !showPassword2"
                        :rules="[rules.required, rules.passCounter]"
                        :counter="20"
                        @keydown.space.prevent=""
                        require
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- Name... -->
              <v-row>
                <v-col class="pt-0 pb-0">
                  <v-row>
                    <v-col class="pt-0 pb-0">
                      <v-text-field
                        v-model="info.name"
                        label="姓名"
                        :rules="InputRules"
                        :counter="10"
                        require
                      ></v-text-field>
                    </v-col>
                    <v-col class="pt-0 pb-0">
                      <v-text-field
                        v-model="info.phone"
                        label="電話"
                        :rules="phoneRules"
                        :counter="18"
                        @keydown.space.prevent=""
                        require
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!--  -->
              <v-row>
                <v-col class="pt-0 pb-0">
                  <v-text-field
                    v-model="info.line"
                    label="LineID"
                    :counter="32"
                    @keydown.space.prevent=""
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- Material -->
              <v-row>
                <v-col class="pt-0 pb-0">
                  <v-textarea
                    v-model="info.material"
                    label="匯款資料"
                    rows="4"
                  ></v-textarea>
                </v-col>
              </v-row>
              <!-- Memo -->
              <v-row>
                <v-col class="pt-0 pb-0">
                  <v-textarea
                    v-model="info.memo"
                    label="備註"
                    rows="4"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
            <v-alert
              v-if="status2.registerFaile"
              dense
              outlined
              type="error"
              :icon="status2.err.icon"
              :color="status2.err.color"
            >
              {{ status2.err.text }}
            </v-alert>
            <v-alert
              v-if="status2.registerSuccess"
              dense
              outlined
              type="success"
            >
              已成功送出申請
            </v-alert>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-row class="pr-1 text-end">
              <v-col class="pt-0">
                <v-btn
                  elevation="4"
                  color="success"
                  @click="handleOnSubmitRegister"
                  :loading="isSendRegister"
                >
                  <v-icon>mdi-content-save</v-icon>
                  送出申請
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
export default {
  props: ['dialogLogin'],
  data() {
    return {
      dialog: true,
      showPassword: false,
      rules: {
        required: v => !!v || '不可為空.',
        userCounter: v => !(v && v.length < 6) || '字數不可少於六個字',
        passCounter: v => !(v && v.length < 6) || '字數不可少於六個字'
      },
      user: process.env.NODE_ENV === 'development' ? 'agent01' : null,
      pass: process.env.NODE_ENV === 'development' ? '123456' : null,
      // user: null,
      // pass: null
      // Dialog for register
      dialog2: false,
      showPassword2: false,
      info: {
        account: '',
        password: '',
        name: '',
        phone: '',
        line: '',
        material: '',
        memo: ''
      },
      InputValid: false,
      InputRules: [
        v => !!v || '不可空白',
        v => v.length <= 10 || '不可超過10個字'
      ],
      phoneRules: [
        v => !!v || '不可空白',
        v => Number.isInteger(Number(v)) || '必須是數字',
        v => v.length === 10 || '字數錯誤'
      ],
      //
      nothing: undefined
    }
  },
  watch: {
    dialogLogin() {
      this.dialog = true
    }
  },
  computed: {
    ...mapState('account', ['isSendRegister', 'status2']),
    ...mapGetters('forward', ['getFeatureEnb'])
  },
  methods: {
    ...mapActions('account', ['login2', 'register2']),
    //
    ...mapMutations('account', ['clearRegister']),
    //
    handleOnLogin() {
      const { user, pass } = this
      if (!user || !pass) return
      if (user.length < 5 || pass.length < 6) return
      ;(async () => {
        await this.login2({ user, pass })
        if (this.status2.loggedIn) this.dialog = false
      })()
    },
    handleOnRegister() {
      this.clearRegister()
      this.dialog = false
      this.dialog2 = true
      if (this.$refs['my-page3-register-form'])
        this.$refs['my-page3-register-form'].resetValidation()
    },
    handleOnSubmitRegister() {
      if (!this.$refs['my-page3-register-form'].validate()) return
      const { info } = this
      this.register2({ info })
    }
  },
  created() {
    // if (process.env.NODE_ENV === 'development') {
    //   this.info.account = 'fmember1'
    //   this.info.password = '123456'
    //   this.info.name = 'fm1'
    //   this.info.phone = '1234567890'
    //   this.info.line = '123'
    //   this.info.material = '1\n2\n3\n4'
    //   this.info.memo = 'a\nb\nc\nd'
    // }
  }
}
</script>

<style>
/* #loginForm div,
.v-content div {
  background-color: rgba(37, 37, 37, 0.9) !important;
} */
</style>
